import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { TimeOffCreateFlowService } from '@app/modules/time-off-v3/services';
import { TimeOffApprovalFlow } from '@models/time-off-v3/time-off-approval-flow.model';
import { TimeOffPolicy } from '@models/time-off-v3/time-off-policy.model';
import { TimeOffType } from '@models/time-off-v3/time-off-type.model';

@Component({
    selector: 'app-basic-information-update-card',
    templateUrl: './basic-information-update-card.template.html',
    styleUrls: ['./basic-information-update-card.style.scss'],
    viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
})
export class BasicInformationUpdateCardComponent implements OnInit {
    @Input() timeOffPolicy = new TimeOffPolicy();
    @Input() timeOffTypes: TimeOffType[] = [];
    @Input() timeOffApprovalFlows: TimeOffApprovalFlow[] = [];
    @Input() isLoading = false;
    @Output() onCreateTimeOffType = new EventEmitter<boolean>();
    timeOffTypeDisabled = false;

    constructor(private timeOffCreateFlowService: TimeOffCreateFlowService) {}

    async ngOnInit(): Promise<void> {
        this.timeOffTypeDisabled = this.timeOffPolicy.isPersisted && this.timeOffPolicy.hasEmployeesAssigned;
    }

    onTimeOffTypeChange(timeOffTypeId: number): void {
        if (timeOffTypeId === -1) {
            this.onCreateTimeOffType.emit(true);
            const timeOffType = new TimeOffType({ unitOfTimePluralTranslation: 'days' });

            let timeOffApprovalFlow = undefined;

            if (this.timeOffPolicy.timeOffApprovalFlowId) {
                timeOffApprovalFlow = this.timeOffApprovalFlows.find(
                    (approvalFlow: TimeOffApprovalFlow) => approvalFlow.id === this.timeOffPolicy.timeOffApprovalFlowId
                );
            }

            this.timeOffPolicy = new TimeOffPolicy({
                ...this.timeOffCreateFlowService.timeOffPolicyDefaultValues,
                name: this.timeOffPolicy.name,
                timeOffTypeId: -1, // We will null this out when sending a request. Currently keep it for the mat-select
                timeOffApprovalFlowId: this.timeOffPolicy.timeOffApprovalFlowId,
                timeOffType: timeOffType,
            });

            if (timeOffApprovalFlow) {
                this.timeOffPolicy.timeOffApprovalFlow = timeOffApprovalFlow;
            }

            this.timeOffCreateFlowService.updateTimeOffPolicy(this.timeOffPolicy);
            this.timeOffCreateFlowService.updateTimeOffType(timeOffType);
            return;
        }

        const selectedTimeOffType = this.timeOffTypes.find(
            (timeOffType: TimeOffType) => timeOffType.id === timeOffTypeId
        );

        this.timeOffPolicy.timeOffTypeId = selectedTimeOffType?.id;
        this.timeOffCreateFlowService.updateTimeOffPolicy(this.timeOffPolicy);
        this.timeOffCreateFlowService.updateTimeOffType(selectedTimeOffType ?? new TimeOffType());

        this.onCreateTimeOffType.emit(false);
    }

    onApprovalFlowChange(approvalFlowId: number): void {
        const selectedApprovalFlow = this.timeOffApprovalFlows.find(
            (approvalFlow: TimeOffApprovalFlow) => approvalFlow.id === approvalFlowId
        );
        this.timeOffPolicy.timeOffApprovalFlow = selectedApprovalFlow ?? new TimeOffApprovalFlow();
        this.timeOffPolicy.timeOffApprovalFlowId = selectedApprovalFlow?.id;
        this.timeOffCreateFlowService.updateTimeOffPolicy(this.timeOffPolicy);
    }
}
